import { ACTIONS } from "./actions";

const initialState = {
    loading: false,
    success: false,
    error: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.CREATE_PROMOTIONS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case ACTIONS.CREATE_PROMOTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
            };
        case ACTIONS.CREATE_PROMOTIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default reducer;
